import * as actions from './actions';
import { GET_ASSETS_TO_SUPPLY, GET_USERS_SUPPLIES, SET_USERS_SUPPLIES } from './constants';
import { Token } from 'src/api/borrow';

export type UserSupply = {
    balance?: string;
    apy?: string;
    reward?: string;
    agreementAddress?: string;
    agreementTitle?: string;
    totalDeposited?: string;
    thresholdOnTotalDeposit?: string;
    tokenAddress?: string;
    tokenSymbol?: string;
    tokenDecimals?: number;
};

export type Fund = {
    ids: Array<string>;
    isVisible: boolean;
    balances: {
        [symbol: string]: number;
    };
    addresses: {
        [symbol: string]: string;
    };
};

export type SuppliesState = {
    userSuppliesLoading: boolean;
    userSupplies: UserSupply[];
    assetsToSupplyLoading: boolean;
    assetsToSupply: Token[];
    fund: Fund;
    hasUserSupplies: boolean;
};

const defaultState: SuppliesState = {
    userSuppliesLoading: false,
    userSupplies: [],
    assetsToSupplyLoading: false,
    assetsToSupply: [],
    fund: {
        ids: [],
        balances: {},
        addresses: {},
        isVisible: false,
    },
    hasUserSupplies: false,
};

type OrderAction = ReturnType<TInferValueTypes<typeof actions>>;

export default function supplies(state = defaultState, action: OrderAction): SuppliesState {
    switch (action.type) {
        case GET_USERS_SUPPLIES: {
            return {
                ...state,
                userSuppliesLoading: true,
            };
        }
        case SET_USERS_SUPPLIES: {
            return {
                ...state,
                userSuppliesLoading: false,
                userSupplies: action.payload,
                hasUserSupplies: action.payload.length > 0,
            };
        }
        case GET_ASSETS_TO_SUPPLY: {
            return {
                ...state,
                assetsToSupplyLoading: true,
            };
        }
        default: {
            return state;
        }
    }
}
